const STORAGE_KEY = "gruim-ai-chat-settings";

export const syncAiConfigToLocalStorage = () => {
  const envValues = {
    modelType: process.env.SVELTE_APP_AI_PROVIDER,
    secretToken: process.env.SVELTE_APP_AI_API_KEY,
    selectedModel: process.env.SVELTE_APP_AI_MODEL,
  };

  let settings = {};
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) settings = JSON.parse(stored);
  } catch {
    settings = {};
  }

  let changed = false;
  for (const [key, value] of Object.entries(envValues)) {
    if (value && !settings[key]) {
      settings[key] = value;
      changed = true;
    }
  }

  if (changed) localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
};
